import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="機曜文化"
        brandName="機曜文化"
        englishName="GIYAO"
        tagline="探索科技、設計與創意，掌握變動中的新知"
      />
      <Footer />
    </>
  );
}

